module.exports = __webpack_public_path__ + "img/mafia_shadow.98c97455.jpg";